import { render, staticRenderFns } from "./ExtendedHeader.vue?vue&type=template&id=4598791e&scoped=true"
import script from "./ExtendedHeader.vue?vue&type=script&lang=js"
export * from "./ExtendedHeader.vue?vue&type=script&lang=js"
import style0 from "./ExtendedHeader.vue?vue&type=style&index=0&id=4598791e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4598791e",
  null
  
)

export default component.exports